import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  action?: React.ReactNode;
  footer?: React.ReactNode;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  title,
  action,
  footer,
  noPadding = false
}: CardProps) {
  return <div className={`bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden ${className}`} data-id="element-171">
      {(title || action) && <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50/50" data-id="element-172">
          {title && <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider" data-id="element-173">
              {title}
            </h3>}
          {action && <div data-id="element-174">{action}</div>}
        </div>}
      <div className={noPadding ? '' : 'p-6'} data-id="element-175">{children}</div>
      {footer && <div className="px-6 py-4 bg-gray-50 border-t border-gray-100" data-id="element-176">
          {footer}
        </div>}
    </div>;
}